import ReactStars from 'react-rating-stars-component';
import { RatingProps } from './types';
import './Rating.scss';

export const Rating: React.FC<RatingProps> = ({
  label,
  value,
  count = 5,
  error,
  disabled,
  onChange,
}) => {
  return (
    <div className={`d-flex flex-column rating ${disabled && 'disabled'}`}>
      <label className="form-label">
        {label}
        <span>*</span>
      </label>
      <ReactStars
        readonly={disabled}
        count={count}
        size={30}
        value={value}
        onChange={onChange}
      />
      {error && (
        <span className="error-text">
          {typeof error === 'object' ? error.join(', ') : error}
        </span>
      )}
    </div>
  );
};
